import React from 'react';
import RoundedIcon from '../../../media/components/rounded-icon/RoundedIcon';
import styles from './OverlayErrors.module.scss';

interface IUserConsentError {
  title: string;
  description: string;
  className?: string;
  descriptionClassName?: string;
  containerClassName?: string;
  titleClassName?: string;
}

export function GenericOverlayError({
  description,
  className = '',
  descriptionClassName = '',
  titleClassName = '',
  containerClassName = '',
  title
}: IUserConsentError) {
  return (
    <div className={`${styles.userConsentWarning} ${className}`}>
      <div className={`${styles.userConsentWarningContainer} ${containerClassName}`}>
        <RoundedIcon iconName='password' containerBg='error' className='mb-4' />

        <div className='center-flex-col mb-4'>
          <span className={`mb-2 text-subheading-2 ${titleClassName}`}>{title}</span>

          <span className={`${styles.helperText} ${descriptionClassName}`}>{description}</span>
        </div>
      </div>
    </div>
  );
}
